import { ImagesService } from './../../service/images.service';
import { ClassificationResultDataModel } from './../../model/classificationDetection.model';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { iaTag, ValuesIaTag } from '../../model/iaTag.model';
import { TchekImage } from '../../model/image';
import { ImageClassification } from '../../model/imageClassification.model';
import { AnnotationService } from '../../service/annotation.service';
import 'parse';
import { Tchekb } from '../../model/tchekb.model';
import { ToastService } from '../../service/toast.service';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-image-classification',
  templateUrl: './image-classification.component.html',
  styleUrls: ['./image-classification.component.less']
})
export class ImageClassificationComponent implements OnInit, OnChanges {
  @Input() tchekId: string;
  @Input() insideClassificationImage: boolean;
  @Input() tchekPtr: Tchekb;
  @Input() currentImage: TchekImage;
  imageClassificationList: iaTag[]
  imageClassification: ImageClassification[]
  currentClassification: ImageClassification
  saveTimer: NodeJS.Timer;
  showbutton = true
  resultClassification: ClassificationResultDataModel

  constructor(private _annotationService: AnnotationService,
    private readonly _toastService: ToastService,
    private readonly _imagesService: ImagesService,
    private readonly _imageService: ImagesService) {

  }

  ngOnInit() {
    this._annotationService.getImageClassificationList().then(tags => { this.imageClassificationList = tags })
    if (this.insideClassificationImage !== true) {
      this._annotationService.getImageClassification(this.tchekId).then(tags => {
        this.imageClassification = tags
        this.currentClassification = this.getImageCurrentClassification()
      })
    } else
      this._annotationService.getAllImageClassification().then(tags => {
        console.log(tags);
        this.imageClassification = tags
        this.currentClassification = this.getImageCurrentClassification()
      })

    $(window).resize(() => {
      this.changesize()
    });
  }

  getImageClassificationList(status: string): ValuesIaTag[] {
    if (this.imageClassificationList !== undefined) {
      let tmp = undefined
      let index = this.imageClassificationList.findIndex(c => { return c.label === status })
      if (index !== -1)
        tmp = this.imageClassificationList[index].attributesValues
      return tmp
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentImage && this.currentImage && this.currentImage.id) {
      this.showbutton = true
      this.currentClassification = this.getImageCurrentClassification()
    }
  }

  runClassification() {
    if (!this.insideClassificationImage || this.imageClassification === undefined) return
    this.resultClassification = undefined
    console.log('current image ', this.currentImage);
    this._imagesService.save = false
    this._imagesService.runDetectionImage(this.currentImage.file.url(), undefined, '/classification/image', undefined, undefined, this.currentImage.id)
      .then(r => {
        this.resultClassification = r.data
        console.log('data classification api', this.resultClassification, this.currentClassification);
        this.autoSelectClassificationQuality()
        this.autoSelectClassification()
        this.changesize()
      })
  }

  autoSelectClassificationQuality() {
    if (!this.insideClassificationImage || this.imageClassification === undefined) return
    if (this.resultClassification.visibility.good > this.resultClassification.visibility['not good']
      && this.resultClassification.visibility.good > this.resultClassification.visibility['very good'])
      this.currentClassification.attributes.status = 'good'
    else if (this.resultClassification.visibility['not good'] > this.resultClassification.visibility.good
      && this.resultClassification.visibility['not good'] > this.resultClassification.visibility['very good'])
      this.currentClassification.attributes.status = 'not good'
    else if (this.resultClassification.visibility['very good'] > this.resultClassification.visibility['not good']
      && this.resultClassification.visibility['very good'] > this.resultClassification.visibility.good)
      this.currentClassification.attributes.status = 'very good'
    this.changeStatus()
  }

  autoSelectClassification() {
    if (!this.insideClassificationImage || this.imageClassification === undefined) return
    this.getData(this.resultClassification).forEach(key => {
      key[1].forEach(array => {
        let label = key[0]
        let name = array[0]
        let value = array[1].toFixed(2)
        switch (label) {
          case 'cut':
            label = 'Cut'
            break;
          case 'type':
            label = 'Type'
            break;
          case 'angle':
            label = 'Pose'
            break;
          case 'reason':
            label = 'Reason'
            break;
          case 'type':
            label = 'Type'
            break;
          default:
            break;
        }
        switch (name) {
          case 'screen':
            name = 'screen picture'
            break;
          case 'interior':
            name = 'Interior'
            break;
          case 'distant':
            name = 'Distant'
            break;
          case 'close':
            name = 'Close'
            break;
          case 'cut':
            name = 'Cut'
            break;
          case 'not cut':
            name = 'Not cut'
            break;
          case 'corrupted':
            name = 'corrupted data'
            break;
          case 'Back t34 Driver':
            name = 'Back 3/4 Driver'
            break;
          case 'Back t34 Passenger':
            name = 'Back 3/4 Passenger'
            break;
          case 'Front t34 Driver':
            name = 'Front 3/4 Driver'
            break;
          case 'Front t34 Passenger':
            name = 'Front 3/4 Passenger'
            break;
          case 'Side Passenger':
            name = 'Profil Passenger'
            break;
          case 'Side Driver':
            name = 'Profil Driver'
            break;
          default:
            break;
        }
        if (value > 30 && this.getImageClassificationOptionChecked(label, name) === false) {
          console.log(key, label, name);
          this.toggleCheckbox(undefined, label, name)
        }
      });
    })

  }

  changeStatus() {
    this.currentClassification.attributes.options = []
    this.save()
    this.autoSelectClassification()
    this.changesize()
  }

  changesize() {
    setTimeout(() => {
      if (this.insideClassificationImage) {
        let r1 = document.getElementById('row1').offsetHeight
        let r2 = document.getElementById('row2').offsetHeight
        let c1 = document.getElementById('container1').offsetHeight
        document.getElementById("row3").style.height = (c1 - r1 - r2 - 50) + 'px';
      }
    }, 300);
  }

  getData(obj): any[] {
    let data = Object.entries(obj)
    data.forEach(e => {
      e[1] = this.getgentries(e[1])
    })
    return data
  }

  getgentries(obj): [string, number][] {
    let data: [string, number][] = Object.entries(obj) as [string, number][]
    data.forEach(e => {
      e[1] = e[1] * 100
    })
    return data
  }

  getImageCurrentClassification(): ImageClassification {
    this.runClassification()
    if (this.imageClassification && this.imageClassification.findIndex(c => {
      return (c.imagePtr && c.imagePtr.id === this.currentImage.id)
    }) !== -1) {
      return this.imageClassification[this.imageClassification.findIndex(c => {
        return (c.imagePtr && c.imagePtr.id === this.currentImage.id)
      })]
    } else {
      let newIC = new ImageClassification(new parse.Object("ImageClassification"))
      newIC.attributes = { status: '', options: [] }
      return newIC
    }
  }

  getImageClassificationOptionChecked(label: string, value: string): boolean {
    if (this.currentClassification && this.currentClassification.attributes && this.currentClassification.attributes.options) {
      let indexOption = this.currentClassification.attributes.options.findIndex(c => { return c.name === label })
      if (indexOption === -1) {
        this.currentClassification.attributes.options.push({ name: label, values: [] })
        return false
      }
      else {
        return this.currentClassification.attributes.options[indexOption].values.includes(value)
      }
    } else {
      this.currentClassification.attributes.options = []
      return false
    }
  }

  save() {
    if (this.insideClassificationImage === true) return
    console.log('click save');
    if (this.saveTimer) {
      clearTimeout(this.saveTimer);
      this.saveTimer = undefined;
    }
    let cC = this.currentClassification
    let cI = this.currentImage
    console.log('B time', cC, cI);
    this.saveTimer = setTimeout(() => {
      console.log('time', cC, cI);
      this.saveImageClassification(cC, cI)
      this.saveTimer = undefined;
    }, 1000);
  }



  toggleCheckbox(event, label: string, value: string) {
    console.log('toggle ', label, value);
    if (this.getImageClassificationOptionChecked(label, value)) {
      let indexOption = this.currentClassification.attributes.options.findIndex(c => { return c.name === label })
      this.currentClassification.attributes.options[indexOption].values.splice(
        this.currentClassification.attributes.options[indexOption].values.indexOf(value), 1
      )
    } else {
      let indexOption = this.currentClassification.attributes.options.findIndex(c => { return c.name === label })
      this.currentClassification.attributes.options[indexOption].values.push(value)
    }
    this.save()
    if (event)
      event.stopPropagation();
  }

  async saveImageClassification(currentClassification?: ImageClassification, currentImage?: TchekImage) {


    console.log('run save');
    this._toastService.toastOpen(true)

    let isNew = this.currentClassification.tchekPtr === undefined

    if (this.insideClassificationImage && this.currentImage.tchekPtr.id === 'VATtjUkm1t')
      this.currentImage.tchekPtr = undefined
    if (this.insideClassificationImage) {
      this.showbutton = false
      this.currentImage.classification = true
      await this.currentImage.getParseInstance().save()
    }

    if (currentClassification === undefined) currentClassification = this.currentClassification
    if (currentImage === undefined) currentImage = this.currentImage

    if (currentClassification.userPtr === undefined)
      currentClassification.userPtr = parse.User.current()


    if (currentClassification.tchekPtr === undefined)
      if (this.insideClassificationImage !== true)
        currentClassification.getParseInstance().set('tchekPtr', this.tchekPtr.getParseInstance())
      else if (this.currentImage.tchekPtr)
        currentClassification.getParseInstance().set('tchekPtr', this.currentImage.tchekPtr.getParseInstance())


    if (currentClassification.imagePtr === undefined)
      currentClassification.getParseInstance().set('imagePtr', currentImage.getParseInstance())
    currentClassification.getParseInstance().save().then((savedIC) => {
      this._toastService.toastOpen(false)
      console.log('saved ', savedIC, this.imageClassification);
      if (isNew)
        this.imageClassification.push(new ImageClassification(savedIC))
    }, (error) => {
      console.error('Failed to create new Image Classification: ' + error.code + ' ' + error.message);
      console.warn(error);
    });


  }
}



// WEBPACK FOOTER //
// ./src/app/element/image-classification/image-classification.component.ts